// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import md5 from 'js-md5'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$http = axios
Vue.prototype.course = "/course/"
let cookie = getCookie("society")
Vue.prototype.$md5 = md5
Vue.prototype.cookie = cookie

function getCookie(cookieName) {
	var strCookie = document.cookie;
	var arrCookie = strCookie.split("; ");
	for (var i = 0; i < arrCookie.length; i++) {
		var arr = arrCookie[i].split("=");
		if (cookieName == arr[0]) {
			return arr[1];
		}
	}
	return "";
}


axios.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么，例如加入token
	// 这里我们可以添加一些配置
	config.headers['token'] = localStorage.getItem('token')
	return config; // 别忘了返回config
}, function(error) {
	// 对请求错误做些什么处理
	// Promise.reject(reason)方法 可以返回一个带有拒绝原因reason参数的Promise对象。
	return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	data() {
		return {
			userInfo: {},
			webConfig: {},
		}
	},
	methods: {
		dataInit() {
			this.$http({
				'method': 'get',
				'url': '/account/h2/getMemberInfo/'
			}).then(res => {
				if (res.data.code == 20000) {
					this.userInfo = res.data.data.userInfo
				} else {
					localStorage.removeItem('token')
				}
			})
		},

		getwebconfig() {
			this.$http({
				'method': 'get',
				'url': '/cms/usual/getUsual'
			}).then(res => {
				if (res.data.code == 20000) {
					this.webConfig = res.data.data.usual
				}
			})

		},

	},
	mounted() {
		this.getwebconfig()
	},
	created() {
		this.dataInit()
	},
	router,
	components: {
		App,
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js